import { useEffect, useRef } from 'react'

interface Props {
  profilePicture: string | null
}

export default function CustomCreatePostWrapper(props: Props) {
  const elementRef = useRef<HTMLElement>(null)

  // useEffect(() => {
  //   const checkElement = () => {
  //     const contentElement = elementRef.current
  //     if (contentElement) {
  //     } else {
  //     }
  //   }

  //   // setTimeout makes sure that this function will be placed at the end of stack, therefore we can make sure that element object fully renders before checking
  //   // checkElement()
  //   setTimeout(checkElement, 0)
  // }, [elementRef])

  const profilePic =
    props.profilePicture !== null ? props.profilePicture : '/user_sample.jpg'

  return (
    <div className="relative flex h-auto w-full max-w-[600px] pt-[10px] pr-[25px] pl-[15px]">
      <div className="flex h-auto w-[50px] shrink-0 select-none">
        <div
          data-id="profile-picture"
          className="flex h-[40px] w-[40px] cursor-pointer items-center justify-center rounded-full bg-cover bg-center"
          style={{
            backgroundImage: `url(${profilePic})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        />
      </div>
      <custom-create-post
        ref={elementRef}
        style={{ width: '100%' }} // content-wrapper
      ></custom-create-post>
    </div>
  )
}
